import { motion } from "framer-motion";

export const EASE = [0.25, 1, 0.5, 1];

export function KineticLines({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.13,
}) {
  return (
    <span className={`block ${className}`}>
      {lines.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden pb-[0.12em] -mb-[0.12em]"
          aria-hidden={false}
        >
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p
      className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.28em] text-gold ${className}`}
    >
      {children}
    </p>
  );
}
